const DesignationPath = {
    title: "Modul Jabatan",
    basePath: "/master/jabatan",
    newPath: "/master/designation/baru",
    detailPath: "/master/designation/opsi/:id",
    baseApi: "/master/designation"
}

export default DesignationPath;
